import { css } from '@emotion/react';
import React from 'react';

const AnimatedValidPhone = props => {
  return (
    <svg
      css={css`
        @-webkit-keyframes translate /* Safari and Chrome */ {
          from {
            transform: translateY(0px);
            transform: scale(1);
          }
          to {
            transform: translateY(-8px);
            transform: scale(1.1);
          }
        }

        @keyframes translate {
          from {
            transform: translateY(0px);
            transform: scale(1);
          }
          to {
            transform: translateY(-8px);
            transform: scale(1.1);
          }
        }

        .pop-up {
          animation: translate 1s ease-in-out infinite;
          animation-direction: alternate;
          overflow: visible;
          transform-origin: 60% 30%;
        }
      `}
      id="AnimatedValidPhone_svg__Calque_4"
      x={0} y={0}
      viewBox="0 0 42 47"
      width="70px"
      xmlSpace="preserve"
      {...props}
    >
      <style>{'.AnimatedValidPhone_svg__primary_color{fill:#0028ff}'}</style>
      <path
        d="M37.276 37.021c-.001-.005.001-.01.001-.015a1.235 1.235 0 00-.626-1.088L17.524 24.91a5.275 5.275 0 00-5.202-.021l-8.736 4.938c-.353.2-.57.547-.616.942-.005.047-.019.092-.019.141 0 .067.012.13.022.193-.007-.044-.019-.087-.021-.133l-.001-.06.003 1.976v.05c0 .022.007.042.008.064.028.417.248.787.615.999l19.126 11.008a5.249 5.249 0 002.619.696 5.25 5.25 0 002.583-.676l8.736-4.938c.391-.221.625-.62.633-1.068h.001v-.009l.001-.007-.001-.008v-1.976zM3.833 30.263l8.736-4.938a4.752 4.752 0 012.337-.612c.82 0 1.64.21 2.37.63l19.126 11.008a.74.74 0 01.375.652.74.74 0 01-.381.65l-.103.058-.506.286-8.127 4.594a4.768 4.768 0 01-4.707-.019L4.441 31.919l-.504-.29-.11-.063a.74.74 0 01-.376-.653.742.742 0 01.382-.65zm-.38 1.641zm-.402-.525c-.021-.052-.044-.103-.058-.157.014.054.036.105.058.157zm.143.255c-.037-.05-.074-.099-.102-.153.029.054.066.103.102.153zm33.202 8.02l-8.736 4.938a4.765 4.765 0 01-4.707-.019L3.828 33.565a.739.739 0 01-.373-.641v-.025l-.002-.973.016-.012c.037.027.069.06.109.083l.357.206 18.769 10.803a5.249 5.249 0 002.619.696 5.25 5.25 0 002.583-.676l8.385-4.74.351-.198c.044-.025.078-.059.118-.088l.016.012v.995a.739.739 0 01-.38.647z"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={0.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        d="M26.701 41.75l1.732-1"
      />
      <g className={'pop-up'}>
        <path
          className="AnimatedValidPhone_svg__primary_color"
          d="M34.686 4.286H11.314A3.314 3.314 0 008 7.6v11.371a3.314 3.314 0 003.314 3.314h8.18c.498 0 .976.198 1.328.55l1.564 1.564a1.06 1.06 0 001.499 0l1.564-1.564c.352-.352.83-.55 1.328-.55h7.908a3.314 3.314 0 003.314-3.314V7.6a3.313 3.313 0 00-3.313-3.314z"
        />
        <path
          className="AnimatedValidPhone_svg__primary_color"
          d="M23 7.499a6 6 0 100 12 6 6 0 000-12zm3.072 4.341l-3.857 3.874h-.003c-.049.049-.182.159-.335.159a.505.505 0 01-.337-.164l-1.615-1.615a.115.115 0 010-.164l.513-.513a.115.115 0 01.081-.035c.029 0 .058.012.081.035l1.281 1.281L25.4 11.15a.115.115 0 01.081-.035c.032 0 .061.012.081.035l.505.522c.051.05.051.122.005.168z"
        />
        <g>
          <path
            className="AnimatedValidPhone_svg__primary_color"
            d="M34.686 4.286H11.314A3.314 3.314 0 008 7.6v11.371a3.314 3.314 0 003.314 3.314h8.18c.498 0 .976.198 1.328.55l1.564 1.564a1.06 1.06 0 001.499 0l1.564-1.564c.352-.352.83-.55 1.328-.55h7.908a3.314 3.314 0 003.314-3.314V7.6a3.313 3.313 0 00-3.313-3.314z"
          />
          <path
            d="M23 7.499a6 6 0 100 12 6 6 0 000-12zm3.072 4.341l-3.857 3.874h-.003c-.049.049-.182.159-.335.159a.505.505 0 01-.337-.164l-1.615-1.615a.115.115 0 010-.164l.513-.513a.115.115 0 01.081-.035c.029 0 .058.012.081.035l1.281 1.281L25.4 11.15a.115.115 0 01.081-.035c.032 0 .061.012.081.035l.505.522c.051.05.051.122.005.168z"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
};

export default AnimatedValidPhone;
